export const common = {
  edubox: 'EDUbox',
  talk: 'Predavanje',
  start: 'Počni',
  stop: 'Stop',
  previous: 'Prethodno',
  next: 'Sljedeće',
  error: {
    noConnection: 'Nije moguće spojiti se na poslužitelj',
    invalidRoom: 'Invalidska soba',
  },
};
